import { render, staticRenderFns } from "./VideoLibModal.vue?vue&type=template&id=dd5a6e56"
import script from "./VideoLibModal.vue?vue&type=script&lang=js"
export * from "./VideoLibModal.vue?vue&type=script&lang=js"
import style0 from "./VideoLibModal.vue?vue&type=style&index=0&id=dd5a6e56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports